import script from "./Innovation.vue?vue&type=script&setup=true&lang=js"
export * from "./Innovation.vue?vue&type=script&setup=true&lang=js"

import "./Innovation.vue?vue&type=style&index=0&id=06ac30f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ac30f0"]])

export default __exports__